import * as moment from "moment"
import { ModelAssumptionsUtil } from "src/app/core/v2/state/valuation-process/core/income/model-assumptions-util"
import { CostAssessmentRecordRow, DepreciatedRecordRow } from "../../types"
import { RecordOptions } from "./calculation"
import { normalizeRecords } from "./normalize"
import { recordsHasNullDepreciatedCost, totalCostOfRecords, totalDepreciatedCostOfRecords } from "./utils"

export interface GompertzOptions {
  kind: 'gompertz',
  economicLife: number,
  gompertzA: number
  gompertzB: number
}
interface GompertzParameters {
  a: number,
  b: number
}
export function gompertzMethod(
  records: CostAssessmentRecordRow[],
  recordOptions: RecordOptions,
  options: GompertzOptions
) {
  const { valuationDate, buildingConstructionDate, size } = recordOptions
  const { economicLife, gompertzA, gompertzB } = options
  const parameters: GompertzParameters = {
    a: gompertzA,
    b: gompertzB
  }
  const _records = normalizeRecords(records, recordOptions)
  const _valuationDate = moment(valuationDate)
  const _constructionDate = moment(buildingConstructionDate)
  const yearDiff = ModelAssumptionsUtil._yearsDiff(_valuationDate, _constructionDate)
  const mappedRecords: DepreciatedRecordRow[] = _records.map(item => {
    const depreciatedCost = _depreciatedValue(
      item.total_cost,
      yearDiff,
      parameters
    )
    return {
      ...item,
      depreciated_cost: depreciatedCost,
      depreciated_per_unit: size && size !== 0 ? depreciatedCost / size : 0
    }
  })
  if (recordsHasNullDepreciatedCost(mappedRecords)) return null
  const totalCost = totalCostOfRecords(mappedRecords)
  const totalDepreciatedCost = totalDepreciatedCostOfRecords(mappedRecords)
  return {
    records: mappedRecords,
    graphValues: _graphValues(economicLife, totalCost, parameters),
    totalCost,
    totalDepreciatedCost,
    yearDiff
  }
}
export function gompertz() {}

function _depreciatedValue(
  totalCost: number,
  years: number,
  parameters: GompertzParameters
) {
  const { a, b} = parameters
  return totalCost - (totalCost * (1 - Math.exp(-a*(1 - Math.exp(-b*years)))))
}

function _graphValues(
  economicLife: number,
  totalCost: number,
  parameters: GompertzParameters
) {
  const values: {
    age: number,
    depreciatedValue: number,
    reducingBalancePerYear: number
  }[] = []
  for (let i = 0; i <= economicLife; i++) {
    const depreciatedValue = _depreciatedValue(totalCost, i, parameters)
    const reducingBalancePerYear = i == 0
      ? totalCost - depreciatedValue
      : values[i - 1].depreciatedValue - depreciatedValue

    values.push({
      age: i,
      depreciatedValue,
      reducingBalancePerYear
    })
  }
  return values
}